import { defineStore } from "pinia";
import LoginService from "../../../../../../Services/LoginService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  onUpdated,
} from "vue";
// import { isSubmit } from '../../../../../../../modules/transplant/pages/patientOnboarding/basicInformationForms/basicDetails.vue'

import CommonService from "../../../../../../modules/Inventory/Service/CommonService";
import ItemMasService from "../../../../../../modules/Inventory/Service/ItemMasService";

import SupplierMaster from "../../../../../../modules/Inventory/Service/SupplierMaster";
import WithoutStockAffectService from "../../../../../../modules/Inventory/Service/WithoutStockAffectService";

import AssetMasterService from "../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import SubAssetRelationshipService from "../../../../../../modules/Inventory/Service/AssetManagement/SubAssetRelationshipService";

import {
  AssetItemList,
  AgreementItemList,
  AssetAgreementModel,
} from "../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/assetAgreementModel";
import { SubAsset } from "../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/subAssetItemModel";

import { Result } from "../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/assetItemModel";

import AssetStatusMasterService from "../../../../../../modules/Inventory/Service/AssetManagement/AssetStatusMasterService";

import axios, { AxiosResponse } from "axios";
export const useCommonStore = defineStore({
  id: "CommonStore",

  state: () => ({
    option: {
      locationList: [],
      listAssetByItem: <AssetItemList[]>[],
      listAssetByItemAsset: <AssetItemList[]>[],
      listSubAssetByItemAsset: <SubAsset[]>[],

      listAgreementByItem: <AgreementItemList[]>[],
      listAssetItem: <Result[]>[],

      listAsset: [],
      listPurchaseOrder: [],
      listSupplier: [],
      statusList: [],
      listSupplierByStoreId: [],

      AssetLifecycleStage: [
        //
        { value: 1, name: "Received" },
        { value: 2, name: "In Inspection" },
        { value: 3, name: "Inspection Passed" },
        { value: 4, name: "Inspection Failed" },
        { value: 5, name: "In Storage" },
        { value: 6, name: "In Transit" },
        { value: 7, name: "Delivered to Department" },
        { value: 8, name: "Setup In Progress" },
        { value: 9, name: "Ready for Use" },
        { value: 10, name: "In Use" },
        { value: 11, name: "Pending Return" },
        { value: 12, name: "Returned to Supplier" },
      ],
    },
  }),

  getters: {},
  actions: {
    async Loadlocation() {
      debugger;
      try {
        this.option.locationList = [];
        const response = await CommonService.loadLocationList();
        console.log(response["result"]);

        this.option.locationList = response["result"].map((item) => {
          item.name = item.LocationName;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        // alert(error);
      }
    },

    async LoadPurchaseOrder(purchase, StoreId) {
      debugger;
      try {
        if (purchase) {
          this.option.listPurchaseOrder = [];
          const response = await WithoutStockAffectService.GetListByDocNo(
            purchase,
            StoreId,
            "4,5,6"
          );

          this.option.listPurchaseOrder = response["result"].map((item) => {
            item.label = item.DocNo;
            item.value = item.DocNo;
            return item;
          });
        }
      } catch (error) {
        alert(error);
      }
    },

    //

    async LoadAsset(ItemId, Id, Barcode, HospitalId, BranchId, StoreId) {
      debugger;
      try {
        this.option.listAsset = [];

        const response = await AssetMasterService.getAssetIdbyAutoComplete(
          Barcode,
          HospitalId,
          BranchId,
          StoreId
        );
        //  const data_response = await AssetMasterService.getAssetIdbyAutoComplete(selectedAssetId.value);
        this.option.listAsset = response["result"]
          .filter((e) => e.AssetId != Number(Id))
          .map((item) => {
            item.label = item.BarCode;
            item.value = item.AssetId;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    },

    async LoadSupplier() {
      debugger;
      try {
        this.option.listSupplier = [];
        const response = await SupplierMaster.gettable();
        console.log(response["result"]);

        this.option.listSupplier = response["result"].map((item) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        alert(error);
      }
    },

    async LoadSupplierByStore(StoreId, BranchId) {
      debugger;
      debugger;
      try {
        this.option.listSupplierByStoreId = [];
        const response = await SupplierMaster.GetSuppliersByStoreId(
          StoreId,
          BranchId
        );
        console.log(response["result"]);

        this.option.listSupplierByStoreId = response["result"].map((item) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        alert(error);
      }
    },

    async LoadlistAssetByItemId(ItemId, GrnId, HId, BId, SId, SInDId) {
      debugger;
      try {
        this.option.listAssetByItemAsset = [];
        this.option.listAssetByItem = [];
        this.option.listAgreementByItem = [];

        const response: AxiosResponse<AssetAgreementModel> =
          await AssetMasterService.listAssetByItemId(
            ItemId,
            GrnId,
            HId,
            BId,
            SId,
            SInDId
          );
        console.log(response["result"]);

        this.option.listAssetByItemAsset = response["result"].AssetItemList;

        this.option.listAssetByItem = (response as any)["result"].ItemList;
        this.option.listAgreementByItem = response["result"].AgreementItemList;
      } catch (error) {
        // alert(error);
      }
    },

    async LoadlistSubAssetByItemId(ItemId, HId, BId, SId) {
      debugger;
      try {
        this.option.listSubAssetByItemAsset = [];
        const response: AxiosResponse<AssetAgreementModel> =
          await SubAssetRelationshipService.listSubAssetByItemId(
            ItemId,
            HId,
            BId,
            SId
          );
        console.log(response["result"]);

        this.option.listSubAssetByItemAsset = response["result"];
      } catch (error) {
        // alert(error);
      }
    },
    async LoadAssetItem(StoreId, BrandId, HospitalId) {
      debugger;
      try {
        // alert(StoreId +
        //     BrandId +
        //     HospitalId)
        this.option.listAssetItem = [];
        const response: AxiosResponse<Result> =
          await ItemMasService.getAssetItems(StoreId, BrandId, HospitalId);
        console.log(response["result"]);

        this.option.listAssetItem = response["result"].map((item) => {
          item.label = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        alert(error);
      }
    },

    async LoadStatus() {
      debugger;
      try {
        this.option.statusList = [];
        const response = await AssetStatusMasterService.getdata();
        console.log(response["result"]);

        this.option.statusList = response["result"].map((item) => {
          item.name = item.StatusName;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        alert(error);
      }
    },
  },
});
